import React, { memo } from 'react';

import BaseTextarea from '../../helpers/Textarea';
import BaseInput from '../../helpers/Input';
import BaseSelect from '../../helpers/Select';
import BaseCheckbox from '../../helpers/Checkbox';
import FormGroup from '../../helpers/FormGroup';
import PrettyError from '../../decorators/PrettyError';
import DisplayError from '../../decorators/DisplayError';

const Textarea = PrettyError(DisplayError(BaseTextarea));
const Input = PrettyError(DisplayError(BaseInput));
const Select = PrettyError(DisplayError(BaseSelect));
const Checkbox = PrettyError(DisplayError(BaseCheckbox));

/**
 * Contact executive main info (top part tab).
 */
const ContactExecutiveInfo = ({ onChange, contact, qualities, interests, relations, qualitiesOfExecutive }) => {
  const quality = contact.get('quality');
  const interest = contact.get('interest');
  const relationship = contact.get('relationship');
  const legacySource = contact.get('legacySource');
  const qualOfExecContent = qualitiesOfExecutive.map(qoe => (
    <Checkbox
      key={qoe.get('id')}
      checked={contact.get(qoe.get('field'))}
      id={qoe.get('id')}
      label={qoe.get('name')}
      name={qoe.get('field')}
      onChange={onChange}
      boldOnChecked
    />
  ));
  const nextStep = contact.get('legacyNextStep');

  return (
    <div className="highlight wrap-border-full mb10">
      <div className="row">
        <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3 sm-p0">
          <FormGroup>
            <Select
              className="input-sm"
              id="f-quality"
              label="Quality"
              name="quality"
              onChange={onChange}
              options={qualities}
              value={quality}
              showLabel
              showValue
            />
          </FormGroup>
          <FormGroup>
            <Select
              id="f-interest"
              label="Interest"
              name="interest"
              onChange={onChange}
              options={interests}
              selectClassName="input-sm"
              value={interest}
              showLabel
              showValue
            />
          </FormGroup>
          <FormGroup>
            <Select
              id="f-relation"
              label="Relation"
              name="relationship"
              onChange={onChange}
              options={relations}
              selectClassName="input-sm"
              value={relationship}
              showLabel
              showValue
            />
          </FormGroup>
          <FormGroup>
            <Input
              className="input-sm"
              id="f-source"
              label="Source"
              name="legacySource"
              onChange={onChange}
              placeholder="Source"
              value={legacySource}
              showLabel
            />
          </FormGroup>
        </div>
        <div className="col-xs-12 col-sm-4 col-md-2 col-lg-4 col-xl-3 col-xxl-2 pr1 sm-p0">
          <div className="group-checkbox">{qualOfExecContent}</div>
        </div>

        <div className="col-xs-12 col-sm-5 col-md-7 col-lg-5 col-xl-6 col-xxl-7 sm-p0">
          <FormGroup>
            <Textarea
              id="f-next-step"
              label="Next Step"
              name="legacyNextStep"
              onChange={onChange}
              placeholder="Next Step"
              rows="6"
              value={nextStep}
              showLabel
            />
          </FormGroup>
        </div>
      </div>
    </div>
  );
};

ContactExecutiveInfo.propTypes = {};

export default memo(ContactExecutiveInfo);
